import {
  Tabs,
  TabBar,
  TabList,
  Tab,
  spacingHelper,
  typographyHelper,
  paletteHelper,
} from '@property.com.au/ui-kit';
import Link from '@rea-argonaut/link';
import { FunctionComponent, useMemo } from 'react';
import { styled } from 'styled-components';
import { useUrlContext } from '../../../../../contexts/UrlContext/UrlContext';
import { getSelectedTabIndex } from './helpers/getSelectedTabIndex';

export type SchoolPageTab = {
  title: string;
  fullPath: string;
};

export interface SchoolPageTabsProps {
  tabs: SchoolPageTab[];
}

const SchoolTabsBar = styled(TabBar)`
  margin-bottom: ${spacingHelper('extraSmall')};
`;

const SchoolTabsList = styled(TabList)`
  &,
  ul {
    height: 2.6rem;
  }

  li {
    height: auto;
  }

  .tabButton {
    ${typographyHelper('subtitle02')};
    height: auto;

    &[aria-selected='true'] {
      color: ${paletteHelper('textBrand')};
    }
  }
`;

export const SchoolPageTabs: FunctionComponent<SchoolPageTabsProps> = ({ tabs }) => {
  const { childPath } = useUrlContext();
  const selectedTab = useMemo(() => getSelectedTabIndex({ tabs, childPath }), [tabs, childPath]);

  return (
    <Tabs hideTabBarLine underlineColor="borderBrandStatic" defaultSelectedTab={selectedTab}>
      <SchoolTabsBar>
        <SchoolTabsList>
          {tabs.map((tab) => (
            <Tab
              key={tab.fullPath}
              // @ts-expect-error - Tab component supports 'as' prop, but types are not correct
              as={Link}
              href={tab.fullPath}
              dangerouslySetClassNames={{ tabButton: 'tabButton', floatyLine: 'floatyLine' }}
            >
              {tab.title}
            </Tab>
          ))}
        </SchoolTabsList>
      </SchoolTabsBar>
    </Tabs>
  );
};
